import React from "react";
import { useLocation } from "react-router-dom";
import ApplyGNMForm from "./ApplyGNMForm";
import ApplyParamedicalForm from "./ApplyParamedicalForm";

export default function ApplyFormRouter() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const course = params.get("course")?.trim().toLowerCase();

  if (course === "gnm") return <ApplyGNMForm />;
  if (course === "paramedical") return <ApplyParamedicalForm />;

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>Course not found or not specified.</h2>
      <p>Please use the appropriate application link.</p>
    </div>
  );
}